import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  Text,
} from "@chakra-ui/react";

function NewUserModal({ isOpen, onClose, ModalData }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent w={"95%"} m={"auto"} bg={"#2c333e"} color={"white"}>
        <ModalHeader textAlign={"center"}>{ModalData.title}</ModalHeader>
        <ModalBody textAlign={"center"}>
          {ModalData.text && <Text>{ModalData.text}</Text>}
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={onClose}
            bg={"#ff9f00"}
            display={"block"}
            m={"auto"}
            color={"white"}
            borderBottom={"2px solid"}
            borderColor={"#a86901"}
            _hover={{
              bg: "#ff9f00",
              border: "none",
            }}>
            Fechar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default NewUserModal;
